import axios from "../../../axios/axiosSetup";
import { BASE_URL } from "../../../configs/WebServiceUrl";

const LMS_BASE = `${BASE_URL}/lms`;

// ---- Classes ----
export const lmsGetClasses = (params) =>
  axios.get(`${LMS_BASE}/classes`, { params });

export const lmsCreateClass = (data) =>
  axios.post(`${LMS_BASE}/classes`, data);

export const lmsUpdateClass = (id, data) =>
  axios.put(`${LMS_BASE}/classes/${id}`, data);

export const lmsDeleteClass = (id) =>
  axios.delete(`${LMS_BASE}/classes/${id}`);

// ---- School Classes ----
export const lmsGetSchoolClasses = (schoolId, extraParams = {}) =>
  axios.get(`${LMS_BASE}/school-classes`, { params: { school_id: schoolId, ...extraParams } });

export const lmsGetTeacherClasses = (teacherId) =>
  axios.get(`${LMS_BASE}/school-classes/teacher-classes`, { params: { teacher_id: teacherId } });

export const lmsCreateSchoolClass = (data) =>
  axios.post(`${LMS_BASE}/school-classes`, data);

export const lmsDeleteSchoolClass = (id) =>
  axios.delete(`${LMS_BASE}/school-classes/${id}`);

// ---- Subjects ----
export const lmsGetSubjects = (schoolId) =>
  axios.get(`${LMS_BASE}/subjects`, { params: { school_id: schoolId } });

export const lmsCreateSubject = (data) =>
  axios.post(`${LMS_BASE}/subjects`, data);

export const lmsUpdateSubject = (id, data) =>
  axios.put(`${LMS_BASE}/subjects/${id}`, data);

export const lmsDeleteSubject = (id) =>
  axios.delete(`${LMS_BASE}/subjects/${id}`);

// ---- Class Subjects ----
export const lmsGetClassSubjects = (params) =>
  axios.get(`${LMS_BASE}/class-subjects`, { params });

export const lmsCreateClassSubject = (data) =>
  axios.post(`${LMS_BASE}/class-subjects`, data);

export const lmsDeleteClassSubject = (id) =>
  axios.delete(`${LMS_BASE}/class-subjects/${id}`);

// ---- Chapters ----
export const lmsGetChapters = (params) =>
  axios.get(`${LMS_BASE}/chapters`, { params });

export const lmsCreateChapter = (data) =>
  axios.post(`${LMS_BASE}/chapters`, data);

export const lmsUpdateChapter = (id, data) =>
  axios.put(`${LMS_BASE}/chapters/${id}`, data);

export const lmsDeleteChapter = (id) =>
  axios.delete(`${LMS_BASE}/chapters/${id}`);

// ---- Topics ----
export const lmsGetTopics = (params) =>
  axios.get(`${LMS_BASE}/topics`, { params });

export const lmsCreateTopic = (data) =>
  axios.post(`${LMS_BASE}/topics`, data);

export const lmsUpdateTopic = (id, data) =>
  axios.put(`${LMS_BASE}/topics/${id}`, data);

export const lmsDeleteTopic = (id) =>
  axios.delete(`${LMS_BASE}/topics/${id}`);

// ---- Study Materials ----
export const lmsGetMaterials = (params) =>
  axios.get(`${LMS_BASE}/study-materials`, { params });

const resolveSchoolId = () => {
  try {
    const u = JSON.parse(localStorage.getItem("userData") || "{}");
    return u.school_id || u.admin_id || null;
  } catch { return null; }
};

export const lmsUploadMaterial = (formData) => {
  const school_id = formData.get("school_id") || resolveSchoolId();
  const url = school_id
    ? `${LMS_BASE}/study-materials/upload?school_id=${school_id}`
    : `${LMS_BASE}/study-materials/upload`;
  return axios.post(url, formData, { headers: { "Content-Type": "multipart/form-data" } });
};

export const lmsAddVideoUrl = (data) =>
  axios.post(`${LMS_BASE}/study-materials/video-url`, data);

export const lmsUpdateMaterial = (id, data) =>
  axios.put(`${LMS_BASE}/study-materials/${id}`, data);

export const lmsDeleteMaterial = (id) =>
  axios.delete(`${LMS_BASE}/study-materials/${id}`);

// ---- Courses ----
export const lmsGetCourses = (params) =>
  axios.get(`${LMS_BASE}/courses`, { params });

export const lmsGetCoursesByClassId = (classId, schoolId) =>
  axios.get(`${LMS_BASE}/courses/class/${classId}`, {
    params: schoolId ? { school_id: schoolId } : {},
  });

export const lmsGetCoursesByClassAndStudentId = (classId, studentId, schoolId) =>
  axios.get(`${LMS_BASE}/enrollments/class/${classId}/student/${studentId}`, {
    params: schoolId ? { school_id: schoolId } : {},
  });

export const lmsGetCourseById = (id) =>
  axios.get(`${LMS_BASE}/courses/${id}`);

export const lmsUploadCourseThumbnail = (file) => {
  const fd = new FormData();
  fd.append("thumbnail", file);
  return axios.post(`${LMS_BASE}/courses/thumbnail`, fd);
};

export const lmsCreateCourse = (data) =>
  axios.post(`${LMS_BASE}/courses`, data);

export const lmsUpdateCourse = (id, data) =>
  axios.put(`${LMS_BASE}/courses/${id}`, data);

export const lmsDeleteCourse = (id) =>
  axios.delete(`${LMS_BASE}/courses/${id}`);

// ---- Teachers ----
export const lmsGetTeachers = (params) =>
  axios.get(`${LMS_BASE}/teachers`, { params });

export const lmsGetTeacherById = (id) =>
  axios.get(`${LMS_BASE}/teachers/${id}`);

export const lmsGetTeacherPermissions = (id, school_id) =>
  axios.get(`${LMS_BASE}/teachers/${id}/permissions`, { params: { school_id } });
export const lmsSaveTeacherPermissions = (id, data) =>
  axios.post(`${LMS_BASE}/teachers/${id}/permissions`, data);
export const lmsCheckTeacherPermission = (id, school_id, module) =>
  axios.get(`${LMS_BASE}/teachers/${id}/permissions/check`, { params: { school_id, module } });

export const lmsCreateTeacher = (formData) => {
  const school_id = formData instanceof FormData ? formData.get("school_id") : formData?.school_id;
  const sid = school_id || resolveSchoolId();
  const url = sid ? `${LMS_BASE}/teachers?school_id=${sid}` : `${LMS_BASE}/teachers`;
  return axios.post(url, formData, { headers: { "Content-Type": "multipart/form-data" } });
};

export const lmsUpdateTeacher = (id, formData) => {
  const school_id = formData instanceof FormData ? formData.get("school_id") : formData?.school_id;
  const sid = school_id || resolveSchoolId();
  const url = sid ? `${LMS_BASE}/teachers/${id}?school_id=${sid}` : `${LMS_BASE}/teachers/${id}`;
  return axios.put(url, formData, { headers: { "Content-Type": "multipart/form-data" } });
};

export const lmsDeleteTeacher = (id) =>
  axios.delete(`${LMS_BASE}/teachers/${id}`);

export const lmsGetTeacherClassSubjects = (teacherId) =>
  axios.get(`${LMS_BASE}/teachers/${teacherId}/class-subjects`);

export const lmsAssignTeacherClassSubject = (teacherId, data) =>
  axios.post(`${LMS_BASE}/teachers/${teacherId}/class-subjects`, data);

export const lmsRemoveTeacherClassSubject = (teacherId, csId) =>
  axios.delete(`${LMS_BASE}/teachers/${teacherId}/class-subjects/${csId}`);

export const lmsGetCoursesByTeacher = (teacherId) =>
  axios.get(`${LMS_BASE}/teachers/${teacherId}/courses`);

export const lmsGetTeacherByUserId = (userId) =>
  axios.get(`${LMS_BASE}/teachers/by-user/${userId}`);

// ---- Course Teachers ----
export const lmsGetCourseTeachers = (courseId) =>
  axios.get(`${LMS_BASE}/courses/${courseId}/teachers`);

export const lmsAssignCourseTeacher = (courseId, data) =>
  axios.post(`${LMS_BASE}/courses/${courseId}/teachers`, data);

export const lmsRemoveCourseTeacher = (courseId, teacherId) =>
  axios.delete(`${LMS_BASE}/courses/${courseId}/teachers/${teacherId}`);

export const lmsGetCourseMaterials = (courseId) =>
  axios.get(`${LMS_BASE}/courses/${courseId}/materials`);

// ---- Students ----
export const lmsGetStudents = (params) =>
  axios.get(`${LMS_BASE}/students`, { params });

export const lmsGetCoachingToken = (schoolId) =>
  axios.get(`${LMS_BASE}/students/coaching-token/${schoolId}`);

export const lmsVerifyCoachingSchool = (id) =>
  axios.get(`${LMS_BASE}/students/verify-school/${id}`);

export const lmsRegisterStudentRequest = (data) =>
  axios.post(`${LMS_BASE}/students/registration-request`, data);

export const lmsGetRegistrationRequests = (params) =>
  axios.get(`${LMS_BASE}/students/registration-requests`, { params });

export const lmsApproveRegistrationRequest = (id, data) =>
  axios.put(`${LMS_BASE}/students/registration-requests/${id}/approve`, data);

export const lmsRejectRegistrationRequest = (id, data) =>
  axios.put(`${LMS_BASE}/students/registration-requests/${id}/reject`, data);

export const lmsCreateStudent = (formData) => {
  if (formData instanceof FormData) {
    const school_id = formData.get("school_id") || resolveSchoolId();
    const url = school_id ? `${LMS_BASE}/students?school_id=${school_id}` : `${LMS_BASE}/students`;
    return axios.post(url, formData, { headers: { "Content-Type": "multipart/form-data" } });
  }
  return axios.post(`${LMS_BASE}/students`, formData);
};

export const lmsUpdateStudent = (id, formData) => {
  if (formData instanceof FormData) {
    const school_id = formData.get("school_id") || resolveSchoolId();
    const url = school_id ? `${LMS_BASE}/students/${id}?school_id=${school_id}` : `${LMS_BASE}/students/${id}`;
    return axios.put(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  return axios.put(`${LMS_BASE}/students/${id}`, formData);
};

export const lmsDeleteStudent = (id) =>
  axios.delete(`${LMS_BASE}/students/${id}`);

// ---- Enrollments & Payments ----
export const lmsCreateEnrollments = (data) => {
  if (data instanceof FormData) {
    return axios.post(`${LMS_BASE}/enrollments`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  return axios.post(`${LMS_BASE}/enrollments`, data);
};

export const lmsSubmitStudentCourseRequest = (data) => {
  if (data instanceof FormData) {
    return axios.post(`${LMS_BASE}/enrollments/student-request`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  return axios.post(`${LMS_BASE}/enrollments/student-request`, data);
};

export const lmsApproveStudentCourseRequest = (enrollmentId, data) =>
  axios.put(`${LMS_BASE}/enrollments/${enrollmentId}/approve`, data);

export const lmsRejectStudentCourseRequest = (enrollmentId, data) =>
  axios.put(`${LMS_BASE}/enrollments/${enrollmentId}/reject`, data);

export const lmsGetEnrollmentsByStudentId = (studentId, schoolId) =>
  axios.get(`${LMS_BASE}/enrollments/student/${studentId}`, {
    params: schoolId ? { school_id: schoolId } : {},
  });

// ---- Exams ----
export const lmsGetExams = (params) =>
  axios.get(`${LMS_BASE}/exams`, { params });

export const lmsGetExamById = (id) =>
  axios.get(`${LMS_BASE}/exams/${id}`);

export const lmsCreateExam = (data) =>
  axios.post(`${LMS_BASE}/exams`, data);

export const lmsUpdateExam = (id, data) =>
  axios.put(`${LMS_BASE}/exams/${id}`, data);

export const lmsDeleteExam = (id) =>
  axios.delete(`${LMS_BASE}/exams/${id}`);

// ---- Question Papers (PDF) ----
export const lmsGetQuestionPapers = (params) =>
  axios.get(`${LMS_BASE}/question-papers`, { params });

export const lmsUploadQuestionPaper = (formData) => {
  const sid = (formData instanceof FormData ? formData.get("school_id") : null) || resolveSchoolId();
  const url = sid ? `${LMS_BASE}/question-papers/upload?school_id=${sid}` : `${LMS_BASE}/question-papers/upload`;
  return axios.post(url, formData, { headers: { "Content-Type": "multipart/form-data" } });
};

export const lmsUpdateQuestionPaper = (id, data) =>
  axios.put(`${LMS_BASE}/question-papers/${id}`, data);

export const lmsDeleteQuestionPaper = (id) =>
  axios.delete(`${LMS_BASE}/question-papers/${id}`);

// ---- Answer Sheets ----
export const lmsGetAnswerSheets = (params) =>
  axios.get(`${LMS_BASE}/answer-sheets`, { params });

export const lmsUploadAnswerSheet = (formData) => {
  const sid = (formData instanceof FormData ? formData.get("school_id") : null) || resolveSchoolId();
  const url = sid ? `${LMS_BASE}/answer-sheets/upload?school_id=${sid}` : `${LMS_BASE}/answer-sheets/upload`;
  return axios.post(url, formData, { headers: { "Content-Type": "multipart/form-data" } });
};

export const lmsReviewAnswerSheet = (id, data) =>
  axios.put(`${LMS_BASE}/answer-sheets/${id}/review`, data);

export const lmsDeleteAnswerSheet = (id) =>
  axios.delete(`${LMS_BASE}/answer-sheets/${id}`);

export const lmsGetSheetMarks  = (id)       => axios.get(`${LMS_BASE}/answer-sheets/${id}/marks`);
export const lmsSaveSheetMarks = (id, data) => axios.put(`${LMS_BASE}/answer-sheets/${id}/marks`, data);

// ---- Manual Question Papers ----
export const lmsGetManualPapers = (params) =>
  axios.get(`${LMS_BASE}/manual-papers`, { params });

export const lmsGetManualPaperById = (id) =>
  axios.get(`${LMS_BASE}/manual-papers/${id}`);

export const lmsCreateManualPaper = (data) =>
  axios.post(`${LMS_BASE}/manual-papers`, data);

export const lmsUpdateManualPaper = (id, data) =>
  axios.put(`${LMS_BASE}/manual-papers/${id}`, data);

export const lmsDeleteManualPaper = (id) =>
  axios.delete(`${LMS_BASE}/manual-papers/${id}`);

// Sections
export const lmsCreateSection = (paperId, data) =>
  axios.post(`${LMS_BASE}/manual-papers/${paperId}/sections`, data);

export const lmsUpdateSection = (id, data) =>
  axios.put(`${LMS_BASE}/manual-papers/sections/${id}`, data);

export const lmsDeleteSection = (id) =>
  axios.delete(`${LMS_BASE}/manual-papers/sections/${id}`);

// Questions
export const lmsCreateQuestion = (sectionId, data) =>
  axios.post(`${LMS_BASE}/manual-papers/sections/${sectionId}/questions`, data);

export const lmsUpdateQuestion = (id, data) =>
  axios.put(`${LMS_BASE}/manual-papers/questions/${id}`, data);

export const lmsDeleteQuestion = (id) =>
  axios.delete(`${LMS_BASE}/manual-papers/questions/${id}`);

// Options
export const lmsUpdateOption = (id, data) =>
  axios.put(`${LMS_BASE}/manual-papers/options/${id}`, data);

// ---- Live Classes (BigBlueButton) ----
export const lmsGetLiveClasses = (params) =>
  axios.get(`${LMS_BASE}/live-classes`, { params });
export const lmsSyncLiveClassStatus = () =>
  axios.post(`${LMS_BASE}/live-classes/sync-status`);

export const lmsGetLiveClassById = (id) =>
  axios.get(`${LMS_BASE}/live-classes/${id}`);

export const lmsCreateLiveClass = (data) =>
  axios.post(`${LMS_BASE}/live-classes`, data);

export const lmsUpdateLiveClass = (id, data) =>
  axios.put(`${LMS_BASE}/live-classes/${id}`, data);

export const lmsDeleteLiveClass = (id) =>
  axios.delete(`${LMS_BASE}/live-classes/${id}`);

export const lmsGetLiveClassJoinUrl = (id, params) =>
  axios.get(`${LMS_BASE}/live-classes/${id}/join`, { params });

export const lmsGetLiveClassStatus = (id) =>
  axios.get(`${LMS_BASE}/live-classes/${id}/status`);

export const lmsEndLiveClass = (id) =>
  axios.post(`${LMS_BASE}/live-classes/${id}/end`);

export const lmsGetLiveClassRecordings = (id, params) =>
  axios.get(`${LMS_BASE}/live-classes/${id}/recordings`, { params });

export const lmsDownloadRecording = (liveClassId, recordId, data) =>
  axios.post(`${LMS_BASE}/live-classes/${liveClassId}/recordings/${recordId}/download`, data);

export const lmsRecordingStatus = (recordId) =>
  axios.get(`${LMS_BASE}/live-classes/recordings/${recordId}/status`);

// ---- Recordings Library ----
export const lmsGetAllRecordings  = (params) => axios.get(`${LMS_BASE}/recordings`, { params });
export const lmsToggleShareRec    = (id, data) => axios.patch(`${LMS_BASE}/recordings/${id}/share`, data);
export const lmsDeleteRecording   = (id) => axios.delete(`${LMS_BASE}/recordings/${id}`);
export const lmsStreamRecording   = (id) => `${LMS_BASE}/recordings/${id}/stream`;

// ---- Live Class Attendance / Audit Log ----
export const lmsRecordAttendance = (liveClassId, data) =>
  axios.post(`${LMS_BASE}/live-classes/${liveClassId}/attendance`, data);

export const lmsGetAttendance = (liveClassId) =>
  axios.get(`${LMS_BASE}/live-classes/${liveClassId}/attendance`);

export const lmsRecordLeave = (liveClassId, attendanceId) =>
  axios.patch(`${LMS_BASE}/live-classes/${liveClassId}/attendance/${attendanceId}/leave`);

// ---- Session Control (one account = one active session) ----
export const lmsGetActiveSession = (userId) =>
  axios.get(`${LMS_BASE}/live-classes/sessions/active`, { params: { user_id: userId } });

export const lmsRegisterSession = (data) =>
  axios.post(`${LMS_BASE}/live-classes/sessions`, data);

export const lmsEndSession = (sessionId) =>
  axios.delete(`${LMS_BASE}/live-classes/sessions/${sessionId}`);

// ---- Audit Log ----
export const lmsGetAuditLog = (params) =>
  axios.get(`${LMS_BASE}/live-classes/audit-log`, { params });

// ---- Manual Attendance ----
export const lmsGetManualAttendance = (params) =>
  axios.get(`${LMS_BASE}/live-classes/attendance`, { params });

export const lmsMarkManualAttendance = (data) =>
  axios.post(`${LMS_BASE}/live-classes/attendance`, data);

export const lmsGetAttendanceReport = (params) =>
  axios.get(`${LMS_BASE}/live-classes/attendance/report`, { params });

export const lmsGetMonthlyAttendanceReport = (params) =>
  axios.get(`${LMS_BASE}/live-classes/attendance/monthly`, { params });

// ---- Waiting Room ----
export const lmsRequestJoinWaitingRoom = (liveClassId, data) =>
  axios.post(`${LMS_BASE}/live-classes/${liveClassId}/waiting-room`, data);

export const lmsGetWaitingRoom = (liveClassId) =>
  axios.get(`${LMS_BASE}/live-classes/${liveClassId}/waiting-room`);

export const lmsCheckWaitingStatus = (liveClassId, userId) =>
  axios.get(`${LMS_BASE}/live-classes/${liveClassId}/waiting-room/status`, { params: { user_id: userId } });

export const lmsApproveWaitingUser = (liveClassId, requestId) =>
  axios.post(`${LMS_BASE}/live-classes/${liveClassId}/waiting-room/${requestId}/approve`);

export const lmsRejectWaitingUser = (liveClassId, requestId) =>
  axios.post(`${LMS_BASE}/live-classes/${liveClassId}/waiting-room/${requestId}/reject`);

// ---- Block / Revoke Participant ----
export const lmsBlockParticipant = (liveClassId, data) =>
  axios.post(`${LMS_BASE}/live-classes/${liveClassId}/block`, data);

export const lmsUnblockParticipant = (liveClassId, userId) =>
  axios.delete(`${LMS_BASE}/live-classes/${liveClassId}/block/${userId}`);

export const lmsGetBlockedUsers = (liveClassId) =>
  axios.get(`${LMS_BASE}/live-classes/${liveClassId}/block`);

export const lmsKickParticipant = (liveClassId, data) =>
  axios.post(`${LMS_BASE}/live-classes/${liveClassId}/kick`, data);

// ---- Live Class Invitations ----
export const lmsGetInvitations = (liveClassId) =>
  axios.get(`${LMS_BASE}/live-classes/${liveClassId}/invitations`);

export const lmsSendInvitations = (liveClassId, data) =>
  axios.post(`${LMS_BASE}/live-classes/${liveClassId}/invitations`, data);

export const lmsRevokeInvitation = (liveClassId, invId) =>
  axios.delete(`${LMS_BASE}/live-classes/${liveClassId}/invitations/${invId}`);

// ---- Polls ----
export const lmsCreatePoll    = (liveClassId, data) =>
  axios.post(`${LMS_BASE}/live-classes/${liveClassId}/polls`, data);
export const lmsGetPolls      = (liveClassId) =>
  axios.get(`${LMS_BASE}/live-classes/${liveClassId}/polls`);
export const lmsGetActivePoll = (liveClassId) =>
  axios.get(`${LMS_BASE}/live-classes/${liveClassId}/polls/active`);
export const lmsVotePoll      = (liveClassId, pollId, data) =>
  axios.post(`${LMS_BASE}/live-classes/${liveClassId}/polls/${pollId}/vote`, data);
export const lmsClosePoll     = (liveClassId, pollId) =>
  axios.post(`${LMS_BASE}/live-classes/${liveClassId}/polls/${pollId}/close`);

// ---- Q&A ----
export const lmsSubmitQuestion  = (liveClassId, data) =>
  axios.post(`${LMS_BASE}/live-classes/${liveClassId}/polls/qa`, data);
export const lmsGetQA           = (liveClassId, params) =>
  axios.get(`${LMS_BASE}/live-classes/${liveClassId}/polls/qa`, { params });
export const lmsGetPendingQA    = (liveClassId) =>
  axios.get(`${LMS_BASE}/live-classes/${liveClassId}/polls/qa/pending`);
export const lmsApproveQuestion = (liveClassId, msgId) =>
  axios.patch(`${LMS_BASE}/live-classes/${liveClassId}/polls/qa/${msgId}/approve`);
export const lmsMarkAnswered    = (liveClassId, msgId) =>
  axios.patch(`${LMS_BASE}/live-classes/${liveClassId}/polls/qa/${msgId}/answer`);
export const lmsDeleteQAMessage = (liveClassId, msgId) =>
  axios.delete(`${LMS_BASE}/live-classes/${liveClassId}/polls/qa/${msgId}`);
export const lmsGetStudentPaymentHistory = (studentId, schoolId) =>
  axios.get(`${LMS_BASE}/enrollments/student/${studentId}/payments`, {
    params: schoolId ? { school_id: schoolId } : {},
  });

export const lmsGetStudentCourseRequests = (studentId, schoolId) =>
  axios.get(`${LMS_BASE}/enrollments/student/${studentId}/course-requests`, {
    params: schoolId ? { school_id: schoolId } : {},
  });

export const lmsGetStudentEnrolledCourses = (studentId, schoolId) =>
  axios.get(`${LMS_BASE}/students/${studentId}/enrolled-courses`, {
    params: schoolId ? { school_id: schoolId } : {},
  });

export const lmsGetStudentAllCourses = (studentId, schoolId, classId) =>
  axios.get(`${LMS_BASE}/students/${studentId}/all-courses`, {
    params: {
      ...(schoolId ? { school_id: schoolId } : {}),
      ...(classId ? { class_id: classId } : {}),
    },
  });

// ---- Payment Configuration ----
export const lmsGetPaymentConfigBySchoolId = (schoolId) =>
  axios.get(`${LMS_BASE}/payment-config/school/${schoolId}`);

export const lmsGetPaymentConfigs = (params) =>
  axios.get(`${LMS_BASE}/payment-config`, { params });

export const lmsSavePaymentConfig = (data) =>
  axios.post(`${LMS_BASE}/payment-config`, data);

export const lmsUpdatePaymentConfig = (id, data) =>
  axios.put(`${LMS_BASE}/payment-config/${id}`, data);

export const lmsDeletePaymentConfig = (id) =>
  axios.delete(`${LMS_BASE}/payment-config/${id}`);

export const lmsPublishQuestionPaper = (data) =>
  axios.post(`${LMS_BASE}/exams/publish-paper`, data);

export const lmsUnpublishQuestionPaper = (id) =>
  axios.delete(`${LMS_BASE}/exams/publish-paper/${id}`);

export const lmsGetExamsBySchool = (school_id) =>
  axios.get(`${LMS_BASE}/exams/by-school/${school_id}`);

// ---- Batches ----
export const lmsGetBatches = (params) =>
  axios.get(`${LMS_BASE}/batches`, { params });

export const lmsGetBatchById = (id) =>
  axios.get(`${LMS_BASE}/batches/${id}`);

export const lmsCreateBatch = (data) =>
  axios.post(`${LMS_BASE}/batches`, data);

export const lmsUpdateBatch = (id, data) =>
  axios.put(`${LMS_BASE}/batches/${id}`, data);

export const lmsDeleteBatch = (id) =>
  axios.delete(`${LMS_BASE}/batches/${id}`);
// ---- Notice Board ----
export const lmsCreateNotice = (data) =>
  axios.post(`${LMS_BASE}/notices`, data);

export const lmsGetNotices = (params) =>
  axios.get(`${LMS_BASE}/notices`, { params });

export const lmsGetStudentNotices = (studentId, params) =>
  axios.get(`${LMS_BASE}/notices/student/${studentId}`, { params });

export const lmsGetNoticeById = (noticeId) =>
  axios.get(`${LMS_BASE}/notices/${noticeId}`);

export const lmsGetNoticeRecipients = (noticeId) =>
  axios.get(`${LMS_BASE}/notices/${noticeId}/recipients`);

export const lmsMarkNoticeRead = (noticeId, studentId) =>
  axios.put(`${LMS_BASE}/notices/${noticeId}/read`, { student_id: studentId });

export const lmsDeleteNotice = (noticeId) =>
  axios.delete(`${LMS_BASE}/notices/${noticeId}`);

// ---- Chat (standalone — independent of the Notice Board) ----
// A chat thread is identified by (student_id, staff_type, staff_id); there's
// no separate "thread" entity, it exists implicitly once a message is sent.
export const lmsGetChatMessages = (params) =>
  axios.get(`${LMS_BASE}/chats/messages`, { params });

export const lmsPostChatMessage = (data) =>
  axios.post(`${LMS_BASE}/chats/messages`, data);

export const lmsGetStaffChatThreads = (params) =>
  axios.get(`${LMS_BASE}/chats/staff-threads`, { params });

export const lmsGetStudentChatThreads = (studentId) =>
  axios.get(`${LMS_BASE}/chats/student/${studentId}/threads`);

export const lmsMarkChatThreadRead = (data) =>
  axios.put(`${LMS_BASE}/chats/read`, data);
export const lmsExtractOCR         = (id, questions) => axios.post(`${LMS_BASE}/answer-sheets/${id}/ocr`, { questions });
export const lmsGetAnswerSheetById = (id) => axios.get(`${LMS_BASE}/answer-sheets/${id}`);

// ---- Certificates ----
export const lmsUploadCertImage    = (file) => {
  const formData = new FormData();
  formData.append("image", file);
  return axios.post(`${LMS_BASE}/certificates/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const lmsGetCertTemplate    = (params) => {
  const q = typeof params === "object" && params !== null ? params : { exam_id: params };
  return axios.get(`${LMS_BASE}/certificates/template`, { params: q });
};
export const lmsSaveCertTemplate   = (data) => axios.post(`${LMS_BASE}/certificates/template`, data);
export const lmsGetCertificates    = (params) => axios.get(`${LMS_BASE}/certificates`, { params });
export const lmsGetCertificateById = (id) => axios.get(`${LMS_BASE}/certificates/${id}`);
export const lmsIssueCertificate   = (data) => axios.post(`${LMS_BASE}/certificates/issue`, data);
export const lmsBulkIssueCerts     = (data) => axios.post(`${LMS_BASE}/certificates/bulk-issue`, data);
export const lmsDeleteCertificate  = (id) => axios.delete(`${LMS_BASE}/certificates/${id}`);

// ---- Grading Criteria ----
export const lmsGetGradingCriteria  = (schoolId) =>
  axios.get(`${LMS_BASE}/grading-criteria`, { params: { school_id: schoolId } });
export const lmsSaveGradingCriteria = (data) =>
  axios.post(`${LMS_BASE}/grading-criteria`, data);

